// src/pages/Login.jsx
import { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import FancyButton from '../../components/ui/fancyButton';
import { supabase } from '../../services/supabaseClient/supabaseClient';
import AuthLayout from '../../components/Auth/authLayout';
// Optional Redux
import { setUser } from '../../redux/authSlice';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // Get the redirect path from location state, default to dashboard
  const from = location.state?.from || '/dashboard';

  const handleLogin = async () => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setMessage(error.message);
    } else {
      setMessage('Logged in successfully.');
      dispatch(setUser(data.user)); // optional
      navigate(from); // 🚀 Redirect to original page or dashboard
    }
  };

  return (
    <AuthLayout title="Welcome Back">
      <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <FancyButton variant="primary" onClick={handleLogin}>
        Login
      </FancyButton>

      <Link
        to="/reset-password"
        style={{ marginTop: '12px', display: 'inline-block', color: '#0077B6' }}
      >
        Forgot password?
      </Link>

      <div style={{ marginTop: '16px', textAlign: 'center' }}>
        <span style={{ color: '#666' }}>Don&apos;t have an account? </span>
        <Link to="/signup" style={{ color: '#0077B6', fontWeight: '500' }}>
          Sign up
        </Link>
      </div>

      {message && <p>{message}</p>}
    </AuthLayout>
  );
};

export default Login;
